var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CrudList',{attrs:{"title":"Términos y condiciones","storeName":"Terms","labelAddNew":"Agregar nuevo ítem","sortable":"","canSearch":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }